export const toLocalIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Parse a date or datetime string (e.g. "2026-01-15" or "2026-01-15 00:00:00Z")
 * into a local Date at midnight by taking only the leading date portion. Returns
 * null for empty or unparseable values.
 */
export const parseLocalIsoDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const parsed = new Date(`${value.slice(0, 10)}T00:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** IANA timezone from the browser (e.g. America/Los_Angeles), for server-side date fallbacks. */
export const getBrowserIanaTimeZone = (): string =>
  // eslint-disable-next-line new-cap
  Intl.DateTimeFormat().resolvedOptions().timeZone;
